import {FORM_VALID_MESSAGE, PHONES_PREFIX_THREE, PHONES_PREFIX_FORE, PHONES_PREFIX_REPLACE} from "./constant";
import {BASE_URL} from "./api";

export function isMobile() {
  const matcher = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  if (window.navigator.userAgent.match(matcher)) {
    return true
  } else {
    return false
  }
}

/**
 *
 * @param type 1: 注册， 2：登陆
 * @param data Form表单
 * @returns {} 错误信息
 */
export function validForm(type, data) {
  let title = type == 1 ? FORM_VALID_MESSAGE.registerFailTitle : FORM_VALID_MESSAGE.loginFailTitle
  let errorMsg = {};
  if (type == 2) {
    if (!data.username || !data.password) {
      errorMsg.title = FORM_VALID_MESSAGE.loginFailTitle
      errorMsg.content = FORM_VALID_MESSAGE.emptyMsg
      return errorMsg
    }
  } else {
    if (!data.username || !data.password || !data.phone || !data.email) {
      errorMsg.title = FORM_VALID_MESSAGE.registerFailTitle
      errorMsg.content = FORM_VALID_MESSAGE.emptyMsg
      return errorMsg
    }
  }
  if (data.username.length < 4 || data.username.length > 20) {
    errorMsg.title = title
    errorMsg.content = FORM_VALID_MESSAGE.usernameFormatErr
    return errorMsg
  }
  if (data.password.length < 6 || data.password.length > 15) {
    errorMsg.title = title
    errorMsg.content = FORM_VALID_MESSAGE.passwordMsg
    return errorMsg
  }
  if (type == 1) {
    if ((data.email !== "" && !/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(data.email)) ||
      String(data.email).toLowerCase().indexOf("icloud") > -1) {
      errorMsg.title = FORM_VALID_MESSAGE.registerFailTitle
      errorMsg.content = FORM_VALID_MESSAGE.emailInvalid
      return errorMsg
    }
    const reg = /^\d{10,11}$/
    if (!reg.test(data.phone)) {
      errorMsg.title = FORM_VALID_MESSAGE.registerFailTitle
      errorMsg.content = FORM_VALID_MESSAGE.phoneInvalid
      return errorMsg
    } else if (data.phone.length == 10 && !PHONES_PREFIX_THREE.includes(data.phone.substr(0, 3)) ||
      data.phone.length == 11 && !PHONES_PREFIX_FORE.includes(data.phone.substr(0, 4))) {
      errorMsg.title = FORM_VALID_MESSAGE.registerFailTitle
      errorMsg.content = FORM_VALID_MESSAGE.phoneInvalid
      return errorMsg
    }
  }
  return errorMsg
}

/**
 * 跳转平台
 * @param url
 * @param username
 * @param password
 */
export function encodePlatformUrl(url, username, password, token = '') {
  if(isMobile()){
    // 跳转平台 h5 要跳转login
    return `${url}/login?username=${window.btoa(`${username}&password=${password}&token=${token}`)}`
  }
  return `${url}/?username=${window.btoa(`${username}&password=${password}&token=${token}`)}`
}

export function validatePass(rule, value, callback) {
  if (!value || value === '') {
    callback(new Error('6 - 15 ký tự bao gồm chữ và số '));
  } else {
    if (!/^(?:(?!^[0-9]+$)(?!^[A-Za-z]+$))[0-9A-Za-z~!@#$%^(&*).,?/{}]{6,15}$/.test(value)) {
      callback(new Error('6 - 15 ký tự bao gồm chữ và số '));
    } else {
      callback();
    }
  }
}

/**
 * 校验表单电话号码
 * @param rule
 * @param value
 * @param callback
 */
export function validatePhone(rule, value, callback) {
  if (!value || value === '') {
    callback(new Error('Điền SĐT chính chủ để nhận ưu đãi'));
  } else {
    if (value !== '') {
      if(value.length !== 10) {
        callback(new Error('Số điện thoại phải đúng định dạng 10 số'));
      }
      if (!/^(?:\+84|0)(19|3[2-9]|43|52|5[5-9]|7[0-9]|8[1-9]|9[0-9])\d{7}$/.test(value)) {
        callback(new Error('Số điện thoại không đúng định dạng'));
      }
    }
    callback();
  }
}

export function validateCode(rule, value, callback) {
  if (value === '') {
    callback(new Error('Mã xác minh không được để trống'));
  } else if (!/^\w{4}$/.test(value)) {
    callback(new Error('Mã xác minh chưa chính xác '));
  } else {
    callback();
  }
}

/**
 * 校验表单邮箱
 * @param rule
 * @param value
 * @param callback
 */
export function validateEmail(rule, value, callback) {
  if ((value !== "" && !/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(value)) ||
    String(value).toLowerCase().indexOf("icloud") > -1) {
    callback(new Error(FORM_VALID_MESSAGE.emailInvalid))
  } else {
    callback();
  }
}

export function replacePhonePrefix(phone) {
  if (phone.length == 11 && PHONES_PREFIX_FORE.includes(phone.substr(0, 4))) {
    return `${PHONES_PREFIX_REPLACE[phone.substr(0, 4)]}${phone.substr(4)}`
  } else {
    return phone
  }
}



// WEBPACK FOOTER //
// ./src/utils/tools.js